import Vue from "vue";
import store from "./store";
import router from "./router";
import App from "./App.vue";

import { UPDATE_AUTH_URL, UPDATE_ADMIN_API_URL, UPDATE_LOTTERY_API_URL, UPDATE_TELEGRAM_ADMIN_API_URL } from "@mutations";

// Global Components
import "./global-components";

import "@/libs";
import "@/mixins/general";
import "@/mixins/dialog";
import "@filters";
import "./registerServiceWorker";

require("@core/scss/core.scss");
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

const configUrl =
  process.env.NODE_ENV === `development` ? `${window.location.origin}/config.dev.json` : `${window.location.origin}/config.prod.json`;

Vue.axios.get(configUrl)
  .then(async resp => {
    store.commit(UPDATE_AUTH_URL, resp.data.authUrl);
    store.commit(UPDATE_ADMIN_API_URL, resp.data.adminApiUrl);
    store.commit(UPDATE_LOTTERY_API_URL, resp.data.lotteryApiUrl);
    store.commit(UPDATE_TELEGRAM_ADMIN_API_URL, resp.data.telegramAdminApiUrl);

    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(error => {
    console.error("Failed to load configuration:", error);
    document.body.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: Arial, sans-serif;">
        <div style="text-align: center;">
          <h1>Configuration Error</h1>
          <p>Failed to load application configuration. Please refresh the page or contact support.</p>
          <button onclick="window.location.reload()" style="margin-top: 20px; padding: 10px 20px; cursor: pointer;">
            Retry
          </button>
        </div>
      </div>
    `;
  });
